import React from "react";
import { withTranslation } from "react-i18next";
import { Navigate, Route, Routes } from "react-router-dom";
import AnomalyDashboard from "./AnomalyDashboard";
import AnomalyList from "./AnomalyList";
import MetricAnomalyTimeline from "./MetricAnomalyTimeline/MetricAnomalyTimeline";
import AnomalyRuleConfig from "./AnomalyRuleConfig";
import { AnomalyDetectionProvider } from "./AnomalyDetectionContext";
import AnomalyDetectionProgress from "./AnomalyDetectionProgress";
import "./AnomalyContainer.scss";

const AnomalyContainer = ({ t }) => {
  return (
    <AnomalyDetectionProvider t={t}>
      <div className="anomaly-module" data-testid="anomaly-module">
        <AnomalyDetectionProgress />
        <Routes>
          <Route path="/" element={<Navigate replace to="dashboard" />} />
          <Route path="/dashboard" element={<AnomalyDashboard />} />
          <Route path="/list" element={<AnomalyList />} />
          <Route path="/time_series" element={<MetricAnomalyTimeline />} />
          <Route path="/rule_configs" element={<AnomalyRuleConfig />} />
        </Routes>
      </div>
    </AnomalyDetectionProvider>
  );
};

export default withTranslation()(AnomalyContainer);
